module.exports = __webpack_public_path__ + "img/11.9ee6bdac.jpg";